export default __webpack_public_path__ + "static/media/newsletter.fc208e40.png";